/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { Appbar, Divider, IconButton, List, Text } from 'react-native-paper';
// import { getHeaderTitle } from '@react-navigation/elements';
import { useDispatch, useSelector } from 'react-redux';
import { modalConatiner, modalHeader, theme } from '../theme/theme';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { showLogoutAlert } from '../store/customer.slice';
import { isElectron } from '../services/Utils';
import Modal from 'react-native-modal';
import { fetchOrders, resetData } from '../store/orders.slice';
import { fetchOrderDetails } from '../store/order.details.slice';
import { fetchCafe } from '../store/cafe.slice';

export default function CustomNavigationBar({
  navigation,
  route,
  options,
  back,
  title,
  hideBackButton,
  logout,
  isHomeHeader,
  isSearchItems,
  showCanteenName,
  showOrderId,
  ordersRefreshIcon,
  orderDetailRefreshIcon,
  showCustomerName,
}) {
  const dispatch = useDispatch();
  const order_id = route?.params?.order_id;
  const customer = useSelector(state => state?.customer?.customer);
  const enable_print = customer?.customer_settings?.enable_order_print;
  const showLogoutIcon = customer?.customer_type === 'guest';
  const canteen = useSelector(state => state?.canteen?.canteen);
  const showCustomerLogout = !!customer && !!logout;
  let _title = title;
  const [isModalVisisble, setModalVisible] = useState(false);

  if (showCanteenName) {
    _title = canteen?.canteen_name;
  }

  if (showOrderId && order_id) {
    _title = 'Order:#' + order_id;
  }

  const closeModal = () => {
    setModalVisible(false);
  };


  const goBack = () => {
    if (back) {
      navigation.goBack();
    } else {
      navigation.replace('Splash');
    }
  };

  const logoutHandler = () => {
    closeModal();
    setTimeout(() => {
      dispatch(showLogoutAlert());
    }, 100);
  };

  const homeHeaderTitle = () => {
    return (
      <View>
        <Text variant="titleSmall" style={{ color: '#ffffff', fontSize: 16, textTransform: 'capitalize' }}>
          {customer?.cafe_name}
        </Text>
        <Text numberOfLines={1} variant="titleSmall" style={{ color: '#ffffff', fontSize: 14, textTransform: 'capitalize' }}>
          {customer?.company_name}
        </Text>
      </View>
    );
  };

  const openMenuItem = (routeName) => {
    closeModal();
    setTimeout(() => {
      navigation.push(routeName);
    }, 100);
  };

  const onRefreshOrders = () => {
    dispatch(resetData());
    dispatch(fetchOrders());
  };

  const onRefreshOrderDetails = () => {
    dispatch(fetchOrderDetails({ order_id }));
  };


  const renderModal = () => {
    return (
      <Modal
        animationOutTiming={300}
        coverScreen={true}
        backdropTransitionOutTiming={300}
        hideModalContentWhileAnimating={true}
        isVisible={isModalVisisble}
        onBackButtonPress={closeModal}
        onBackdropPress={closeModal}
        style={modalConatiner}>
        <SafeAreaView style={styles.modalView}>
          <View style={[modalHeader, { backgroundColor: theme.colors.primary }]}>
            <Text variant="titleSmall" style={{ color: theme.colors.onPrimary }}>Actions</Text>
            <IconButton
              icon="close"
              iconColor={theme.colors.onPrimary}
              size={20}
              onPress={closeModal}
            />
          </View>
          <Divider />
          <ScrollView>
            <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'account-outline'} />} title="My Account" onPress={() => openMenuItem('MyAccount')} />
            <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'cube-outline'} />} title="Orders" onPress={() => openMenuItem('Orders')} />
             <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'food-outline'} />} title="Menu" onPress={() => openMenuItem('Menu')} />
            {enable_print &&
              <React.Fragment>
                {Platform.OS === 'android' && <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'printer-outline'} />} title="Printer" onPress={() => openMenuItem('BluetoothPrinter')} />}
                {isElectron() && <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'printer-outline'} />} title="Printer" onPress={() => openMenuItem('ThermalPrinters')} />}
              </React.Fragment>
            }
            <List.Item titleStyle={styles.menuTitleStyle} left={props => <List.Icon style={{ paddingHorizontal: 8 }} icon={'logout'} />} title="Logout" onPress={logoutHandler} />
          </ScrollView>
        </SafeAreaView>
      </Modal>
    );
  };

  if (isHomeHeader) {
    return (
      <Appbar.Header style={[styles.headerContainer, { backgroundColor: theme.colors.primary }]}>
        <Appbar.Content title={homeHeaderTitle()} titleStyle={{ color: theme.colors.onPrimary, fontSize: 16, textTransform: 'capitalize' }} />
        <IconButton
          icon="refresh"
          iconColor={theme.colors.onPrimary}
          size={20}
          onPress={() => dispatch(fetchCafe())}
        />
        <IconButton
          icon="food"
          iconColor={theme.colors.onPrimary}
          size={20}
          onPress={() => navigation.push('Menu')}
        />
        <IconButton
          icon="cube-outline"
          iconColor={theme.colors.onPrimary}
          size={20}
          onPress={() => navigation.push('Orders')}
        />
        {enable_print &&
          <React.Fragment>
            {(Platform.OS === 'android' || isElectron()) && (
              <IconButton
                icon="printer-outline"
                iconColor={theme.colors.onPrimary}
                size={26}
                onPress={() =>
                  openMenuItem(Platform.OS === 'android' ? 'BluetoothPrinter' : 'ThermalPrinters')
                }
              />
            )}
          </React.Fragment>
        }
        {showLogoutIcon && <IconButton
          icon="logout"
          iconColor={theme.colors.onPrimary}
          size={26}
          onPress={logoutHandler}
        />
        }
        <IconButton
          icon="dots-vertical"
          iconColor={theme.colors.onPrimary}
          size={20}
          onPress={() => setModalVisible(_t => !_t)}
        />
        {renderModal()}
      </Appbar.Header>
    );
  }

  return (
    <React.Fragment>
      <Appbar.Header style={[styles.headerContainer, { backgroundColor: theme.colors.primary }]}>
        {isSearchItems && <IconButton
          icon="close"
          iconColor={theme.colors.onPrimary}
          size={26}
          onPress={goBack}
        />
        }
        {(!hideBackButton) ? <Appbar.BackAction color={theme.colors.onPrimary} onPress={goBack} /> : null}
        <Appbar.Content title={_title} subtitle={showCustomerName && 'Hi,' + customer?.name} titleStyle={{ color: '#ffffff', fontSize: 16, textTransform: 'capitalize' }} />
        {!!ordersRefreshIcon &&
          <IconButton
            icon="refresh"
            iconColor={theme.colors.onPrimary}
            size={26}
            onPress={onRefreshOrders}
          />
        }
        {!!orderDetailRefreshIcon &&
          <IconButton
            icon="refresh"
            iconColor={theme.colors.onPrimary}
            size={26}
            onPress={onRefreshOrderDetails}
          />
        }
        {showCustomerLogout && <IconButton
          icon="logout"
          iconColor={theme.colors.onPrimary}
          size={26}
          onPress={logoutHandler}
        />
        }
      </Appbar.Header>
    </React.Fragment>
  );
}

const styles = StyleSheet.create({
  headerContainer: {
    padding: 8,
    flexDirection: 'row',
    alignItems: 'center',
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 0,
    //   height: 1,
    // },
    // shadowOpacity: 0.22,
    // shadowRadius: 2.22,

    // elevation: 0,
  },
  menuTitleStyle: {
    fontSize: 14,
  },
  modalView: {
    minHeight: '20%',
    backgroundColor: '#ffffff',
    paddingBottom: 16,
    borderRadius: 16,
    margin: 6,
  },
});
